module.exports = "<ion-view hide-back-button=\"true\" ng-touchstart=\"handleTouchStart($event)\">\r\n  <ion-nav-title>{{ 'SCHEDULE.SCHEDULE' | translate}}</ion-nav-title>\r\n  <ion-content  \r\n    id=\"wechat-schedule-content\"\r\n    ng-class=\"settings.wechatMiniProgram ? 'wechat-has-header': '' \">\r\n    <iframe name=\"schedule\"\r\n                src=\"\"\r\n                frameborder=\"0\"\r\n                class=\"schedule-modal\"\r\n                id=\"scheduleModal\"></iframe>\r\n  </ion-content>\r\n  <loading ng-class=\"isLoading ? '': 'hide'\"></loading>\r\n  </ion-view>";


//////////////////
// WEBPACK FOOTER
// ./src/views/schedule/schedule.html
// module id = 7W9n
// module chunks = 1